import { render, staticRenderFns } from "./MenuItemKiosk.vue?vue&type=template&id=4d408076&"
import script from "./MenuItemKiosk.vue?vue&type=script&lang=js&"
export * from "./MenuItemKiosk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports